<template>
  <div class="mt-1 mr-1 mb-5" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAddBookEntry"
        title="Crea un nuovo movimento"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
      <b-button
        class="btn--smaller btn--transparent"
        type="button"
        variant="secondary"
        @click="onOpenGenerateBrokerStatements('commission_mode')"
        >Effettua Calcoli Provvigionali
      </b-button>
      <b-button
        class="btn--smaller btn--transparent"
        type="button"
        variant="secondary"
        @click="onOpenGenerateBrokerStatements('broker_statement_mode')"
        >Genera Rendiconti
      </b-button>
      <b-dropdown
        ref="columnsDropdown"
        right
        size="sm"
        toggle-class="btn--smaller btn--transparent"
      >
        <template #button-content>
          <b-icon icon="gear" width="20" height="20"></b-icon>
          <span style="font-size: 14px; font-weight: 500">{{
            dropdownLabel
          }}</span>
        </template>
        <div>
          <b-dropdown-group
            id="dropdown-group-1"
            header="Seleziona le colonne da nascondere"
          >
            <b-dropdown-form @submit.stop.prevent>
              <b-form-checkbox-group
                v-model="hiddenKeys"
                :options="hideableFieldOptions"
                text-field="text"
                value-field="value"
                stacked
                class="mb-3"
              />
              <b-button
                class="btn--transparent"
            variant="secondary"
                size="sm"
                @click="onToggleColumnsAndClose"
                >Modifica Colonne
              </b-button>
            </b-dropdown-form>
          </b-dropdown-group>
        </div>
      </b-dropdown>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <template v-if="canVerb(resource, 'store')">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo movimento </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddBookEntry"
                  title="Crea un nuovo movimento"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </template>
            <template v-else>
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </template>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName, true)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="cod_prod"
                label="Produttore"
                :options="decoratedSalesmenSelect"
                :scrollToValue="lastSelectedSalesmanId"
                v-model="salesmen_ids"
                :multiple="true"
                :closeOnSelect="false"
                :taggable="salesmen_taggable"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
                @input="onSalesmen"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myToggle ? selectAllBrokers() : deselectAllBrokers()
                    "
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
            <div class="filter-item">
              <base-select
                name="int_prod"
                label="Intestazione documenti prodotti"
                :options="intProd"
                v-model="salesman_id"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="insurers"
                label="Compagnia"
                :options="insurers"
                v-model="filter.byInsurer.id"
                :multiple="true"
                :closeOnSelect="false"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="from"
                label="Registrazione Dal"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="to"
                label="Registrazione Al"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item">
              <base-checkbox
                name="arretrati"
                label="Includi"
                v-model="arretrati"
                :chk_val="true"
                :unchk_val="false"
                :isSwitch="true"
                groupLabel="Includi registrazioni escluse dai rendiconti precedenti"
              />
            </div>
            <div class="filter-item">
              <base-radio
                name="calculus_type"
                label="Modalità"
                v-model="calculus_type"
                :options="calculus_options"
                stacked
                @select="onCalculusTypeChange"
              />
            </div>
            <div class="filter-item">
              <!-- NOTA: con :unchk_val="null" => non aggiunge "byExclusion" su queryString -->
              <base-checkbox
                :disabled="!calculus_type"
                name="esclusi"
                label="Escludi"
                v-model="filter.byExclusion"
                :chk_val="true"
                :unchk_val="null"
                :isSwitch="true"
                groupLabel="Escludi dal ricalcolo provvigionale Lisaweb le compagnie e i rami indicati nell'anagrafica Compagnie"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <span class="ml-3 font-weight-bold">
        Modalità Rendiconto:
        {{ $store.state.auth.settings.attributables.STATMOD }}
      </span>
      <span class="font-weight-bold" v-if="salesman_id">
        :: Intestazione documenti prodotti:
        {{ salesmen.find((s) => s.value == salesman_id).text }} :: Dal
        {{ correctDateFormat(filter.byCalendar.from) }} :: Al
        {{ correctDateFormat(filter.byCalendar.to) }}
      </span>
      <b-col class="ml-auto pr-0" cols="auto" align="right"> </b-col>
      <div class="table-wrapper" data-type="overflow-x">
        <salesmen-accounting
          :filterOn="{
            byRelations: [
              'byBookTag',
              'byInsurer',
              'byRegistry',
              'byRegistryGroup',
              'byInsuranceAncillary',
              'byVariousAccounting',
            ],
          }"
          :fields="flds"
          :repository="repository"
          :resource="resource"
          :filterName="filterName"
          :ref="tableRef"
          @rowSelector="updateOne"
          @cellChange="onCellChange"
          @updateFields="updateFields"
          @edit="onEdit"
          @confirm="onConfirm"
          @destroy="onDelete"
          @rowSelector2="onStatementExclude"
          :onlyActions="['edit', 'destroy']"
          includeBottomRow
          noPagination
          includeRowSelector
          hasChecks
        ></salesmen-accounting>
      </div>
      <b-row
        style="margin: 0 0 10px -0.1rem"
        v-show="$refs[tableRef] && $refs[tableRef].items.length"
      >
        <div
          style="
            width: 15px;
            height: 15px;
            background: white;
            margin-left: 18px;
            padding: 0;
            margin-top: 8px;
            font-size: 12px;
            border-radius: 50%;
            translate: 0 1px;
          "
        ></div>
        <p style="padding: 0; margin: 8px 5px 0 5px; font-size: 12px">
          Registrazione in intervallo date
        </p>
        <div
          style="
            width: 15px;
            height: 15px;
            background: pink;
            padding: 0;
            margin: 8px 0 0 10px;
            font-size: 12px;
            border-radius: 50%;
            translate: 0 1px;
          "
        ></div>
        <p style="padding: 0; margin: 8px 5px 0 5px; font-size: 12px">
          Registrazione arretrata
        </p>
        <div
          style="
            width: 15px;
            height: 15px;
            background: orange;
            padding: 0;
            margin: 8px 0 0 10px;
            font-size: 12px;
            border-radius: 50%;
            translate: 0 1px;
          "
        ></div>
        <p style="padding: 0; margin: 8px 5px 0 5px; font-size: 12px">
          Registrazione esclusa dal rendiconto
        </p>
        <div
          style="
            width: 15px;
            height: 15px;
            background: purple;
            padding: 0;
            margin: 8px 0 0 10px;
            font-size: 12px;
            border-radius: 50%;
            translate: 0 1px;
          "
        ></div>
        <p style="padding: 0; margin: 8px 5px 0 5px; font-size: 12px">
          Movimento vario modificabile
        </p>
      </b-row>

      <b-overlay center :show="isUpd" rounded="sm">
        <div
          style="
            margin-left: 1rem;
            display: flex;
            flex-direction: row;
            gap: 10px;
          "
          v-show="!isUpd"
        >
          <b-button
            v-show="$refs[tableRef] && $refs[tableRef].items.length"
            type="button"
            variant="primary"
            class="mt-1"
            @click="updateAll"
            :disabled="changedIds.length == 0"
            >Aggiorna tutti
          </b-button>
          <!-- v-show="
              $refs[tableRef] &&
              $refs[tableRef].items.length &&
            " -->
          <b-button
            v-show="
              $refs[tableRef] &&
              $refs[tableRef].items.length &&
              $refs[tableRef].selectedRows.length &&
              changedIds.length == 0
            "
            type="button"
            variant="lisaweb"
            class="mt-1"
            @click="onReset"
            :disabled="!canShowBrokerStatement"
            >Ricarica
          </b-button>
          <div
            v-show="
              $refs[tableRef] &&
              $refs[tableRef].items.length &&
              $refs[tableRef].selectedRows.length &&
              changedIds.length == 0
            "
          >
            <b-button
              type="button"
              variant="lisaweb"
              class="mt-1"
              @click="drawBrokerStatement"
              :disabled="canShowBrokerStatement"
              >Rendiconto
            </b-button>
          </div>
        </div>
        <div
          v-if="canShowBrokerStatement"
          style="margin-left: 1rem"
          class="mt-1 mb-1"
        >
          <export-options
            :exportUrl="exportUrl"
            :repository="repository"
            :resource="resource"
            :tableRef="$refs[tableRef]"
            class="mb-2"
            :filter="filter"
            :options="[
              {
                code: 'RENPROVUNOFFICIALIZED',
                label: null,
                formats: ['csv', 'pdf'],
                extra: {
                  produttori: smids, // REVIEW: still require this?
                  salesman_id: smid,
                },
              },
            ]"
          ></export-options>
          <!-- // REVIEW: seems that BE does not require all salesmen ids for this report, except the "principal" one.
            Such salesmen will be recognized by BE based on byAttribute[id] array received,
            which is generated here by tableRef later on in ExportsMixin -->
          <!-- <button-group-table
            @pdf="report('pdf')"
            @csv="report('csv')"
            :print="false"
            :options="{
              CSV: { enabled: true },
              PDF: { enabled: true },
            }"
          ></button-group-table> -->
          <!-- tabella riepilogo -->
          <div class="form-card-wrapper">
            <b-card
              :header="getDictionary('balance_sheet')"
              header-tag="header"
            >
              <template #header>
                <b>Rendiconto</b>
              </template>
              <b-card-text>
                <table class="summary">
                  <thead>
                    <tr>
                      <th scope="col" colspan="2">
                        {{ getDictionary("totals") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <!-- premi -->
                      <th scope="row">{{ getDictionary("premiums") }}</th>
                      <td>{{ toLocaleCurrency(summary.entrate) }}</td>
                    </tr>
                    <tr>
                      <!-- Di cui sospesi da incassare -->
                      <th scope="row">
                        {{ getDictionary("of_which_deferred_to_collect") }}
                      </th>
                      <td>{{ toLocaleCurrency(summary.sospesi) }}</td>
                    </tr>
                    <tr>
                      <!-- Acconti -->
                      <th scope="row">
                        {{ getDictionary("advance_payments") }}
                      </th>
                      <td>{{ toLocaleCurrency(summary.acconti) }}</td>
                    </tr>
                    <tr>
                      <!-- Provvigioni -->
                      <th scope="row">{{ getDictionary("commissions") }}</th>
                      <td>
                        {{ toLocaleCurrency(summary.provvigioni) }}
                      </td>
                    </tr>
                    <tr>
                      <!-- di cui non soggette a ritenuta d'acconto -->
                      <th scope="row">
                        {{ getDictionary("of_which_not_taxable") }}
                      </th>
                      <td>{{ toLocaleCurrency(summary.di_cui) }}</td>
                    </tr>
                    <tr>
                      <!-- Ritenuta d'acconto (X%) -->
                      <th scope="row">
                        {{ getDictionary("deduction") }} ({{
                          summary.ritenuta_perc
                        }}%)
                      </th>
                      <td>{{ toLocaleCurrency(summary.ritenuta) }}</td>
                    </tr>
                    <tr>
                      <!-- di cui diritti -->
                      <th scope="row">
                        {{ getDictionary("fees") }}
                      </th>
                      <td>{{ toLocaleCurrency(summary.di_cui_diritti) }}</td>
                    </tr>
                    <tr>
                      <!-- Provvigioni da liquidare -->
                      <th scope="row">
                        {{ getDictionary("commissions_to_liquidate") }}
                      </th>
                      <td>
                        {{ toLocaleCurrency(summary.da_liquidare) }}
                      </td>
                    </tr>
                    <tr>
                      <!-- Saldo premi -->
                      <th scope="row">
                        {{ getDictionary("premiums_balance") }}
                      </th>
                      <td>{{ toLocaleCurrency(summary.saldo) }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-text>
            </b-card>
          </div>
          <!-- Ufficializza Rendiconto -->
          <div class="form-card-wrapper">
            <b-card
              :header="getDictionary('make_official_balance_sheet')"
              header-tag="header"
            >
              <template #header>
                <b>Ufficializza Rendiconto</b>
              </template>
              <!-- <template #header>
                      <div>
                        <b-button
                          type="button"
                          variant="lisaweb"
                          class="mt-1"
                          @click="onSaveBrokerStatement"
                          >Ufficializza Rendiconto</b-button
                        >
                        Uffcializza
                      </div>
                    </template> -->
              <b-card-text>
                <!-- 2 input  -->
                <b-row class="mt-1">
                  <div class="form-group">
                    <!-- Numero fattura -->
                    <base-input
                      :name="getDictionary('invoice_number')"
                      :label="getDictionary('invoice_number')"
                      v-model="form.invoice_number"
                    />
                  </div>
                  <div class="form-group">
                    <!-- Periodo -->
                    <base-input
                      :name="getDictionary('period')"
                      :label="getDictionary('period')"
                      v-model="form.invoice_period"
                    />
                  </div>
                  <div class="form-group col-md-2 align-self-end">
                    <b-button
                      type="button"
                      variant="lisaweb"
                      class="mt-1 btn--smaller"
                      :disabled="!salesman_id"
                      @click="onSaveBrokerStatement"
                      >Ufficializza Rendiconto
                    </b-button>
                  </div>
                </b-row>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <generate-broker-statements-modal
          :ref="generateBrokerStatementModalRef"
          :title="broker_statement_title"
          :header="broker_statement_header"
          @generate="onGenerate"
        ></generate-broker-statements-modal>
        <template #overlay>
          <div class="mt-3 text-center">
            <div class="custom-loader"></div>
            <p class="loading-text">Aggiornamento in corso...</p>
          </div>
        </template>
      </b-overlay>
      <div ref="anchor1"></div>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import GenerateBrokerStatementsModal from "@/components/modals/generateBrokerStatementsModal";
import SalesmenAccounting from "@/components/tables/SalesmenAccounting";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseRadio from "@/components/form/BaseRadio";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import ExportOptions from "@/components/ExportOptions";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import FormMixin from "@/mixins/FormMixin";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { toInfoData } from "@/utils/transforms";
import moment from "moment";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

moment.locale("it");

export default {
  mixins: [
    CustomFiltersMixin,
    ConfirmModalMixin,
    FormMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      exportUrl: null,
      isSaving: false,
      isUpdating: false,
      myToggle: false,
      myTogglePO: false,
      salesmen_ordered: [],
      salesmen_select: [],
      filter: this.initFilter(),
      exportFormat: null,
      context: "accounting_prod_salesmen",
      insurers: [],
      activeFilters: {},
      salesmen_ids: [], // i produttori della tendina multipla
      salesman_id: null, // il produtore selezionato dalla seconda tendina (popolata con i produttori selezionati dalla prima)
      lastSelectedSalesmanId: null, // ultimo produttore per cui è stato ufficializzato un rendiconto (persistito in localStorage)
      arretrati: null,
      show_percentages: "N",
      // esclusi: null,
      calculus_type: 1, // TODO diventerà byQualcosa...
      showCollapse1: true,
      // canBrokerStatement: false,
      canShowBrokerStatement: false,
      changedIds: [],
      prevCheckedItemIds: [],
      filterName: "filterSalesmenAccounting",
      resource: "book_entries",
      repository: "book_entry",
      tableRef: "SalesmenAccountingTableRef",
      fields: [],
      broker_statement_title: null,
      broker_statement_header: null,
      mode: null,
      generateBrokerStatementModalRef: "generateBrokerStatementModal",
      dropdownLabel: "Colonne",
      selectableFields: {
        0: [
          {
            key: "check",
            label: "Sel.",
            sortable: false,
            thClass: "check text-center",
            tdClass: "text-center",
            class: "check",
            hideable: false,
            group: "left",
          },
          {
            key: "deferred",
            label: "Sosp",
            sortable: false,
            hideable: false,
            group: "left",
            hideableLabel: "Sospeso",
          },
          {
            key: "deposited",
            label: "Acc",
            sortable: false,
            hideable: false,
            group: "left",
            hideableLabel: "Acconto",
          },
          {
            key: "book_date",
            label: "D.Reg",
            //sortable: false,
            sortable: true,
            // sortByFormatted: true,
            formatter: (value) => toLocaleDate(value),
            hideable: false,
            group: "left",
          },
          {
            key: "effective_date",
            label: "D.Eff",
            // sortable: false,
            sortable: true,
            // sortByFormatted: true,
            formatter: (value) => toLocaleDate(value),
            hideable: false,
            group: "left",
          },
          // {
          //   key: "title",
          //   label: "Descrizione",
          //   sortable: false,
          // },
          {
            // key: "customer",
            key: "registry_title",
            label: "Contraente/descrizione",
            sortable: true,
            hideable: false,
            group: "left",
            // sortable: true,
            // sortByFormatted: true,
            // vitual: (detail) => {
            //   return detail;
            // },
          },
          {
            key: "registry_group",
            label: "Gruppo",
            sortable: true,
            sortByFormatted: true,
            hideable: true,
            group: "left",
          },
          {
            // key: "insurance_policy",
            key: "insurance_policy_number",
            label: "Polizza",
            // sortable: false,
            sortable: true,
            sortByFormatted: true,
            // formatter: (value) => this.toPolicy(value),
            hideable: true,
            group: "left",
          },
          {
            // key: "book_tag",
            key: "book_tag_code",
            label: "Doc",
            // sortable: false,
            sortable: true,
            sortByFormatted: true,
            // formatter: (value) => this.toBookTag(value),
            hideable: true,
            group: "left",
            hideableLabel: "Codice Documento",
          },
          {
            // key: "company",
            key: "company_code",
            label: "Com",
            // sortable: false,
            sortable: true,
            sortByFormatted: true,
            // formatter: (value) => this.toCompany(value),
            hideable: true,
            group: "left",
            hideableLabel: "Compagnia",
          },
          {
            key: "brokers",
            label: "Prod",
            // sortable: false,
            sortable: true,
            sortByFormatted: true,
            formatter: (value) => this.toBroker(value),
            hideable: true,
            group: "left",
            hideableLabel: "Produttore",
          },
          {
            // key: "branch_risk",
            key: "branch_risk_title",
            label: "Rischio",
            // sortable: false,
            sortable: true,
            sortByFormatted: true,
            // formatter: (value) => this.toBranchAndRisk(value),
            hideable: true,
            group: "left",
          },
          {
            key: "gross",
            label: "Premio",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            group: "left",
            // thStyle: {
            //   width: "125px",
            // },
          },
          {
            key: "net",
            label: "Imp",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            group: "left",
            // thStyle: {
            //   width: "125px",
            // },
          },
          {
            key: "agency_prov_purchase",
            label: "Acq",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Acq.",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "perc_prov_ag_acq",
            label: "%",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Acq. (%)",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "agency_prov_take",
            label: "Inc",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Inc.",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "perc_prov_ag_inc",
            label: "%",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Inc. (%)",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "prov_ag_tot",
            label: "Tot",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Tot.",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "perc_prov_ag_tot",
            label: "%",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v2",
            thClass: "text-right",
            sortable: true,
            hideable: true,
            hideableLabel: "Provv. Ag. - Tot. (%)",
            thStyle: {
              background: "#cdcac8 !important",
            },
            group: "agenzia",
          },
          {
            key: "saler_prov_purchase",
            // label: "Provv.Acq.Prod",
            label: "Acq",
            sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3",
            thClass: "text-right",
            // sortable: true,
            // sortByFormatted: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_acq_ag",
            label: "% Ag",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3 italic",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_acq_im",
            label: "% Im",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          {
            key: "saler_prov_take",
            // label: "Provv.Inc.Prod",
            label: "Inc",
            sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3",
            thClass: "text-right",
            // sortable: true,
            // sortByFormatted: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_inc_ag",
            label: "% Ag",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3 italic",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_inc_im",
            label: "% Im",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          // {
          //   key: "saler_fee_take",
          //   label: "Dir.Inc.Prod",
          //   sortable: false,
          //   formatter: (value) => toLocaleCurrency(value),
          //   tdClass: "text-right",
          //   thClass: "text-right",
          // sortable: true,
          // sortByFormatted: true,
          // thStyle: {
          //   width: "125px",
          // },
          // },
          {
            key: "tot_prod",
            label: "Tot",
            // sortable: false,
            // formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3 bold",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_tot_ag",
            label: "% Ag",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3 italic bold",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          {
            key: "perc_prov_prod_tot_im",
            label: "% Im",
            // sortable: false,
            formatter: (value) => toLocaleCurrency(value),
            tdClass: "text-right bg-light-v3 bold",
            thClass: "text-right",
            sortable: true,
            hideable: false,
            thStyle: {
              background: "#d7d6d6 !important",
              whiteSpace: "nowrap",
            },
            group: "produttore",
          },
          // {
          //   key: "perc_provv",
          //   label: "% Provv",
          //   sortable: false,
          // sortable: true,
          // formatter: (value) => toLocaleCurrency(value),
          // tdClass: "text-right",
          // thClass: "text-right",
          // thStyle: {
          //   width: "125px",
          // },
          // },
          {
            key: "confirmRow",
            label: "Confermato",
            sortable: false,
            hideable: false,
            thClass: "check",
            tdClass: "text-center",
            group: "right",
          },
          // class: "check",
          {
            key: "rowSelector",
            label: "Aggiorna",
            sortable: false,
            hideable: false,
            thStyle: {
              width: "86px",
            },
            group: "right",
          },
          {
            key: "rowSelector2",
            label: "Arretrati",
            sortable: false,
            hideable: false,
            thStyle: {
              width: "70px",
            },
            group: "right",
          },
        ],
        1: [
          {
            key: "id",
            label: "[ID] - Campi per modalità rendicontro Altro DA DEFINIRE",
            sortable: false,
            hideable: false,
          },
        ],
      },
      form: {
        invoice_number: null,
        invoice_period: null,
      },
      summary: {
        entrate: 0,
        sospesi: 0,
        acconti: 0,
        di_cui_disponibili: 0,
        provvigioni: 0,
        di_cui: 0,
        ritenuta: 0,
        ritenuta_perc: 0.0,
        da_liquidare: 0,
        saldo: 0,
      },
      hiddenKeys: [],
      salesmen: [],
      salesmen_taggable: true,
      calculus_options: [
        { value: 0, text: "Utilizza già calcolate" },
        { value: 1, text: "Calcola con Lisaweb" },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseRadio,
    BaseCheckbox,
    BaseDatepicker,
    SalesmenAccounting,
    // ButtonGroupTable,
    ExportOptions,
    // SelectOptionModal,
    GenerateBrokerStatementsModal,
  },
  methods: {
    toLocaleCurrency,
    toInfoData,
    onToggleColumnsAndClose() {
      this.onToggleColumns();
      // Close dropdown programmatically
      this.$refs.columnsDropdown.hide();
      // Update dropdown label only when confirming
      const count = this.hiddenKeys.length;
      this.dropdownLabel = `Colonne${count > 0 ? ` (${count})` : ""}`;
    },
    onToggleColumns() {
      this.selectableFields[0].forEach((field) => {
        if (!field.hideable) return;
        const shouldHide = this.hiddenKeys.includes(field.key);
        this.$set(field, "thClass", shouldHide ? "d-none" : "");
        this.$set(field, "class", shouldHide ? "d-none" : "align-middle");
      });
    },
    updateFields(item) {
      console.log("updateFields before", item);
      item["tot_prod"] = this.totProd(item);
      item["perc_prov_prod_acq_ag"] = this.percentageProvProdAcqAg(item);
      item["perc_prov_prod_acq_im"] = this.percentageProvProdAcqIm(item);
      item["perc_prov_prod_inc_ag"] = this.percentageProvProdIncAg(item);
      item["perc_prov_prod_inc_im"] = this.percentageProvProdIncIm(item);
      item["perc_prov_prod_tot_ag"] = this.percentageProvProdTotAg(item);
      item["perc_prov_prod_tot_im"] = this.percentageProvProdTotIm(item);
      console.log("updateFields after", item);
    },
    /* */
    percentageProvAgAcq(data) {
      if (!data || !data?.net || !data?.agency_prov_purchase) return "-";
      return `${((data.agency_prov_purchase / data.net) * 100)
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    percentageProvAgInc(data) {
      if (!data || !data?.net || !data?.agency_prov_take) return "-";
      return `${((data.agency_prov_take / data.net) * 100)
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    provAgTot(data) {
      if (!data) return "-";
      return toLocaleCurrency(
        data.agency_prov_purchase + data.agency_prov_take,
      );
    },
    totProd(data) {
      return toLocaleCurrency(
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(
              (
                parseFloat(data.saler_prov_purchase || 0) +
                parseFloat(data.saler_prov_take || 0) +
                parseFloat(data.saler_fee_take || 0)
              ).toFixed(2),
            )
          : parseFloat(
              (
                parseFloat(data.purchase_commission || 0) +
                parseFloat(data.take_commission || 0) +
                parseFloat(data.insurer_fee || 0)
              ).toFixed(2),
            ),
      );
    },
    percentageProvAgTot(data) {
      if (
        !data ||
        !data?.net ||
        !data?.agency_prov_purchase ||
        !data?.agency_prov_take
      )
        return "-";
      return `${(
        ((data.agency_prov_purchase + data.agency_prov_take) / data.net) *
        100
      )
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    percentageProvProdAcqAg(data) {
      if (!data || !data?.agency_prov_purchase) return "-";
      const provv =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(parseFloat(data.saler_prov_purchase || 0).toFixed(2))
          : parseFloat(parseFloat(data.purchase_commission || 0).toFixed(2));
      return `${((provv / data.agency_prov_purchase) * 100)
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    percentageProvProdAcqIm(data) {
      if (!data || !data?.net) return "-";
      const provv =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(parseFloat(data.saler_prov_purchase || 0).toFixed(2))
          : parseFloat(parseFloat(data.purchase_commission || 0).toFixed(2));
      return `${((provv / data.net) * 100).toFixed(2).replace(".", ",")}%`;
    },
    percentageProvProdIncAg(data) {
      console.log("agency_prov_take", data.agency_prov_take);
      if (!data || !data?.agency_prov_take) return "-";
      const provv =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(parseFloat(data.saler_prov_take || 0).toFixed(2))
          : parseFloat(parseFloat(data.take_commission || 0).toFixed(2));
      return `${((provv / data.agency_prov_take) * 100)
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    percentageProvProdIncIm(data) {
      if (!data || !data?.net) return "-";
      const provv =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(parseFloat(data.saler_prov_take || 0).toFixed(2))
          : parseFloat(parseFloat(data.take_commission || 0).toFixed(2));
      return `${((provv / data.net) * 100).toFixed(2).replace(".", ",")}%`;
    },
    percentageProvProdTotAg(data) {
      if (!data || !(data?.agency_prov_purchase + data?.agency_prov_take))
        return "-";
      const provv_prod_tot =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(
              (
                parseFloat(data.saler_prov_purchase || 0) +
                parseFloat(data.saler_prov_take || 0) +
                parseFloat(data.saler_fee_take || 0)
              ).toFixed(2),
            )
          : parseFloat(
              (
                parseFloat(data.purchase_commission || 0) +
                parseFloat(data.take_commission || 0) +
                parseFloat(data.insurer_fee || 0)
              ).toFixed(2),
            );
      return `${(
        (provv_prod_tot / (data.agency_prov_purchase + data.agency_prov_take)) *
        100
      )
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    percentageProvProdTotIm(data) {
      if (!data || !data?.net) return "-";
      let provv_prod_tot;
      provv_prod_tot =
        !this.isCalcWithLisa || !this.isChangeable(data)
          ? parseFloat(
              (
                parseFloat(data.saler_prov_purchase || 0) +
                parseFloat(data.saler_prov_take || 0) +
                parseFloat(data.saler_fee_take || 0)
              ).toFixed(2),
            )
          : parseFloat(
              (
                parseFloat(data.purchase_commission || 0) +
                parseFloat(data.take_commission || 0) +
                parseFloat(data.insurer_fee || 0)
              ).toFixed(2),
            );
      return `${((provv_prod_tot / data.net) * 100)
        .toFixed(2)
        .replace(".", ",")}%`;
    },
    /* */
    // toCurrency(value) {
    //   if (!value) value = "0.00001"; // trick to allow display "0.00 €"
    //   return toLocaleCurrency(parseFloat(value));
    // },
    /* */
    toRegistryGroup(data) {
      let ret = "";
      if (
        data?.registries?.[0]?.registry_groups &&
        data.registries[0].registry_groups.length
      ) {
        const found = data.registries[0].registry_groups.find(
          (e) => e.pivot.primary.value === "Y",
        );
        if (found) ret = found.title;
      }
      return ret;
    },
    toCustomer(data) {
      // - se il movimento ha titolo oppure è vario di id 1, mostrare sempre il nome del contraente (insurance_anillaries.length)
      // - se il movimento è di tipo 2 (contabilità produttore) mostrare la descrizione fatta a mano  (title, various_accountings)
      // - se il movimento è di tipo 3 (Acconti) /(various_accountings)
      // - - se ha sia produttore che cliente mostrare “acconto cliente NOMINATIVO” (registry && broker)
      // - - se ha solo produttore mostrare “acconto produttore COD PRODUTTORE” (!registry && broker)
      let ret = "";
      switch (true) {
        case this.hasInsuranceAncillary(data) ||
          this.isVarAccByCode(data, "FC") ||
          this.isVarAccByCode(data, "FCT"):
          ret = this.toInfoData(data.registries[0], "registryfullname");
          break;

        case this.isVarAccByCode(data, "CP"):
          ret = data.various_accountings[0].title;
          break;

        case this.isVarAccByCode(data, "AC"):
          if (
            data.registries &&
            data.registries.length &&
            data.brokers &&
            data.brokers.length
          ) {
            ret = `acconto cliente ${this.toInfoData(
              data.registries[0],
              "registryfullname",
            )}`;
            break;
          }
          if (
            (!data.registries || !data.registries.length) &&
            data.brokers &&
            data.brokers.length
          ) {
            ret = `acconto produttore ${this.toInfoData(
              data.brokers[0],
              "broker",
            )}`;
            break;
            // ret = `acconto produttore ${this.toInfoData(data.brokers[0], "broker", 0)}` // passare status 0?
          }
          break;

        default:
          break;
      }
      // Fallback per valorizzare la colonna "Contraente/descrizione" per i "Movimenti vari modificabili" (viola)
      if (!ret) ret = data?.title;
      return ret;
    },
    toPolicy(data) {
      // - se il movimento ha titolo oppure è vario di id 1, mostrare sempre il numero polizza (occhio che può arrivare da titolo o dal movimento vario, come nella tabella dei fogli cassa)
      //   (various_accounings === 1 (I)|| insurance_ancillaries)()
      // -  se il movimento è di tipo 2 (contabilità produttore)
      // - - se ha lordo != 0 e prov prod inc = 0 mostrare “Registrazione premio”
      // - - se ha lordo = 0 e prov prod inc != 0 mostrare “Registrazione provvigione”
      // - - se ha entrambi != 0 mostrare "registrazione premio/provvigione”
      // - se il movimento è di tipo 3 (Acconti)
      // - - se ha sia produttore che cliente mostrare “acconto cliente”
      // - - se ha solo produttore mostrare “acconto produttore”
      let ret = "";
      switch (true) {
        case this.hasInsuranceAncillary(data) ||
          this.isVarAccByCode(data, "FC") ||
          this.isVarAccByCode(data, "FCT"):
          ret = this.hasInsuranceAncillary(data)
            ? // ? data.insurance_ancillaries[0].number
              data.insurance_ancillaries[0].insurance_policy?.number
            : data.various_accountings && data.various_accountings.length
            ? // ? data.various_accountings[0].number
              data.various_accountings[0].pivot.insurance_policy_number
            : "";
          break;

        case this.isVarAccByCode(data, "CP"):
          switch (true) {
            // prov prod inc ->? saler_prov_take
            case data.gross != 0 && data.saler_prov_take == 0:
              ret = "Registrazione premio";
              break;

            case data.gross == 0 && data.saler_prov_take != 0:
              ret = "Registrazione provvigione";
              break;

            case data.gross != 0 && data.saler_prov_take != 0:
              ret = "Registrazione premio/provvigione";
              break;

            default:
              break;
          }
          break;

        case this.isVarAccByCode(data, "AC"):
          if (
            data.registries &&
            data.registries.length &&
            data.brokers &&
            data.brokers.length
          ) {
            ret = `acconto cliente`;
            break;
          }
          if (
            (!data.registries || !data.registries.length) &&
            data.brokers &&
            data.brokers.length
          ) {
            ret = `acconto produttore`;
            break;
          }
          break;

        default:
          break;
      }
      return ret;
    },
    toBookTag(data) {
      let ret;
      if (!data.book_tags) {
        ret = "";
      } else if (
        this.hasInsuranceAncillary(data) ||
        this.isVarAccByCode(data, "FC") ||
        this.isVarAccByCode(data, "FCT")
      ) {
        ret = data.book_tags.map((e) => e.code).join(",");
      }
      return ret;
    },
    toCompany(data) {
      let ret;
      if (!data.insurer) {
        ret = "";
      } else if (
        this.hasInsuranceAncillary(data) ||
        this.isVarAccByCode(data, "FC") ||
        this.isVarAccByCode(data, "FCT")
      ) {
        ret = data.insurer.code;
      }
      return ret;
    },
    toBroker(data) {
      let ret;
      if (!data) {
        ret = "";
      } else {
        ret = data ? data.map((e) => e.attributables.BUID).join(",") : "";
      }
      return ret;
    },
    toBranchAndRisk(data) {
      // ramo e prodotto come su colonne foglio cassa (ma uniti in unica colonna
      const NOT_IMPORTED_BROKER = 2;
      if (data.various_accountings.length) {
        if (data.various_accountings[0].id === NOT_IMPORTED_BROKER) {
          return data.formatted_title;
        }
      }

      let b =
        data.insurance_ancillaries && data.insurance_ancillaries.length
          ? data.insurance_ancillaries[0].insurance_policy
            ? data.insurance_ancillaries[0].insurance_policy.insurance_risk
              ? `${data.insurance_ancillaries[0].insurance_policy.insurance_risk.risk_branch.code}-${data.insurance_ancillaries[0].insurance_policy.insurance_risk.code}-
                    ${data.insurance_ancillaries[0].insurance_policy.insurance_risk.risk_branch.formatted_title}`
              : ""
            : ""
          : data.various_accountings && data.various_accountings.length
          ? data.various_accountings[0].pivot.insurance_risk
            ? `${data.various_accountings[0].pivot.insurance_risk.risk_branch.code}-${data.various_accountings[0].pivot.insurance_risk.code}-
                  ${data.various_accountings[0].pivot.insurance_risk.risk_branch.formatted_title}
                  `
            : ""
          : "";
      let p =
        data.insurance_ancillaries && data.insurance_ancillaries.length
          ? data.insurance_ancillaries[0].insurance_policy
            ? data.insurance_ancillaries[0].insurance_policy.insurance_risk
                .formatted_title
            : ""
          : data.various_accountings && data.various_accountings.length
          ? data.various_accountings[0].pivot.insurance_risk
            ? data.various_accountings[0].pivot.insurance_risk.formatted_title
            : ""
          : "";
      return `${b} - ${p}`;
    },
    hasInsuranceAncillary(data) {
      return !!(
        data.insurance_ancillaries && data.insurance_ancillaries.length
      );
    },
    /* */
    manualFetch() {
      this.resetAllFilters();
    },
    resetSingleSidebarFilter(name) {
      const salesmenKey = this.calculus_type
        ? "byCommissionApplied.id"
        : "byBroker.id";
      if (name === salesmenKey) {
        this.salesmen_ids = [];
        this.salesman_id = null;
        this.activeFilters = {};
        this.activeFilters = this.retriveActiveFilters();
        this.onSearch(this.filterName);
        return;
      }
      // Delegate to the mixin's implementation for all other filters
      this.accessNestedFilterOption(name);
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    correctDateFormat(date) {
      if (!date) return "-";
      const parsed = moment(date, "YYYY-MM-DD");
      return parsed.isValid() ? parsed.format("DD/MM/YYYY") : "-";
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
      console.log("salesmen_ordered", this.salesmen_ordered);
    },
    selectAllBrokers() {
      this.salesmen_ids = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
      this.onSalesmen();
    },
    deselectAllBrokers() {
      this.salesmen_ids = [];
      this.salesman_id = null;
    },
    initFilter() {
      let init = {
        byAttribute: {
          is_statement_excluded: "N",
          // is_confirmed: "N", // CHECK: dipende dalla modalità? va inviato sempre?
        },
        // #772: un-fixed
        byBrokerStatement: {
          id: "!",
        },
        byInsurer: {
          id: null,
        },
        // byBroker: {
        //   id: null,
        // },
        byCalendar: {
          from: null,
          to: null,
        },
        // byInsurer: {
        //   exclude_calc_vehicle_branch: null,
        //   exclude_calc_extra_vehicle_branch: null,
        //   exclude_calc_life_branch: null,
        // },
        byExclusion: null, // #667: TODO check the real filter name!!!
        // calculus_type: 0, // TODO diventerà byQualcosa...
        // byCommissionApplied: {
        //   salesman: null
        // },
        // arretrati: 0,
      };
      return init;
    },
    // report(format) {
    //   this.exportFormat = format;
    //   this.$bvModal.show("selectOption");
    // },
    // onSelectOption(value) {
    //   if (value != null) {
    //     this.onExport(this.exportFormat, "RENPROVUNOFFICIALIZED", {
    //       // prospetto: this.getTotalizers(),
    //       produttori: this.salesmen_ids,
    //       salesman_id: this.salesman_id,
    //       show_percentages: value,
    //     });
    //   }
    // },
    onAddBookEntry() {
      // have to open the "salesmen" variant of book_entries create
      this.$router.push({
        name: `book_entries.create`,
        params: { mode: "II" },
      });
    },
    onEdit(item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${item.id}`, item: item, mode: "II" },
      });
    },
    onDelete(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          console.debug("successfully deleted!", id);
          // this.$refs[this.tableRef].fetch();
          this.onSearch(this.filterName);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    // onEditByType(id, item) {
    //   // TODO: recuperare il tipo di mov vario da item
    //   // console.log(id, item);
    //   let type = null;
    //   switch (type) {
    //     case 1:
    //       break;

    //     default:
    //       break;
    //   }
    // },
    onSalesmen() {
      // console.log("onSalesmen:", id);
      // se c'è almeno 1 salesmen_ids...
      if (this.salesmen_ids.length) {
        // ...setta come preselezionato il 1° in ordine di selezione nella seconda tendina intProd
        this.salesman_id = this.salesmen_ids[0];
        this.onSalesman(this.salesman_id);
        // ...setta come preselezionato il 1° in ordine di id nella seconda tendina intProd
        // this.salesman_id = Math.min(...this.salesmen_ids);
      } else {
        this.salesman_id = null;
        this.summary.ritenuta_perc = 0.0;
      }
    },
    lastSelectedSalesmanStorageKey() {
      return `salesmen_last_selected_user_${this.$store.state.auth.user.id}`;
    },
    loadLastSelectedSalesman() {
      let stored = null;
      try {
        stored = localStorage.getItem(this.lastSelectedSalesmanStorageKey());
      } catch (error) {
        // localStorage non disponibile (es. private browsing): nessun produttore da marcare
      }
      this.lastSelectedSalesmanId = stored ? Number(stored) : null;
    },
    saveLastSelectedSalesman(id) {
      if (!id) return;
      try {
        localStorage.setItem(this.lastSelectedSalesmanStorageKey(), id);
      } catch (error) {
        // localStorage non disponibile: non blocca il flusso del rendiconto
      }
      this.lastSelectedSalesmanId = id;
    },
    onSalesman(val) {
      // la seconda tendina
      // recupero il WHT
      let found = this.$store.state.auth.salesmen.find((e) => e.id == val);
      if (found) {
        this.summary.ritenuta_perc = found.attributables.WHT
          ? parseFloat(found.attributables.WHT)
          : 0.0;
      } else {
        this.summary.ritenuta_perc = 0.0;
      }
    },
    onConfirm(item) {
      // devo solo abilitare il bottone aggiorna... senza salvare
      // CHECK quale dei 2 approcci?

      // NOTA: non è memorizzato il valore al "caricamento", ma solo il valore "attuale"
      // 1. se Y aggiunge, se N rimuove
      // if (item.is_confirmed.value == "Y") {
      //   this.addToChangedIds(item.id);
      // } else {
      //   this.removeFromChangedIds(item.id);
      // }

      // 2. aggiungo sempre, sia Y sia N
      this.addToChangedIds(item.id);
    },
    /* onConfirm(item) {
      // salvo immediatamente
      // per la PUT del campo is_confirmed, vanno inviati tutti i campi mandatory
      // 1. chiamare: edit/item.id
      // 2. preparare payload con campi obbligatori oltre a is_confirmed
      console.debug("onConfirm", item);
      let id = item.id;
      this.fetchEditForm("book_entry", id)
        .then(() => {
          this.initMandatoryFields("book_entry");
          // save
          let payload = {};
          payload = { ...this.mandatoryFields[this.repository] };
          this.setMandatoryValues(this.repository, payload);
          // set values for fields with rules: required_without_all
          this.setRequiredWithoutAll(payload, item);
          // payload = { ...payload, ...form };

          payload["is_confirmed"] = item.is_confirmed.value;

          let msg =
            item.is_confirmed.value === "Y" ? "confermato" : "non confermato";

          this.update(this.repository, id, payload)
            .then(() => {
              this.$showSnackbar({
                preset: "success",
                text: `Azione Completata: ${msg}`,
              });
              // fetch table data?
              // this.table.fetch().then(() => {
              //   this.fetchForm().finally(() => {
              //     this.isLoading = false;
              //   });
              // });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    }, */
    onStatementExclude(item) {
      // console.debug("onStatementExclude", item);
      let payload = {};
      payload["agency_prov_purchase"] = item?.agency_prov_purchase;
      payload["agency_prov_take"] = item?.agency_prov_take;
      payload["saler_prov_purchase"] = item?.saler_prov_purchase;
      payload["saler_prov_take"] = item?.saler_prov_take;
      payload["saler_fee_take"] = item?.saler_fee_take;
      payload["is_confirmed"] = item?.is_confirmed?.value;
      payload["is_statement_excluded"] = "Y"; // item.is_statement_excluded.value;

      const Repo = RepositoryFactory.get("book_entry");
      Repo.commission_update(item.id, payload)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: arretrato escluso`,
          });
          this.onSearch(this.filterName);
          // fetch table data?
          // this.table.fetch().then(() => {
          //   this.fetchForm().finally(() => {
          //     this.isLoading = false;
          //   });
          // });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onCellChange(id) {
      this.addToChangedIds(id);
      // accendo is_confirmed
      this.setConfirmedRow(id);
    },
    addToChangedIds(id) {
      // add to global list
      if (this.changedIds.indexOf(id) === -1) {
        this.changedIds.push(id);
        // REVIEW: devo impostare is_confirmed per tutti a 'Y'?
        // set is_confirmed = Y
        // this.setConfirmedRow(id);
      }

      // console.debug("this.changedIds: ", this.changedIds);
    },
    removeFromChangedIds(id) {
      // this.changedIds = this.changedIds.filter((e) => {
      //   return e !== id;
      // });
      let index = this.changedIds.indexOf(id);
      if (index !== -1) {
        this.changedIds.splice(index, 1);
      }
    },
    setChangedIds(data) {
      this.changedIds = [];
      data.forEach((item) => {
        // if calculated value is different, then row must be updatable...
        if (
          // item.saler_prov_purchase != item.purchase_commission ||
          // item.saler_prov_take != item.take_commission
          // #1045: take2: fix 6.81, 7.81 arrivano come X.8100000000000005
          this.$refs[this.tableRef].isChangeable(item) &&
          (parseFloat(item.saler_prov_purchase).toFixed(2) !=
            parseFloat(item.purchase_commission).toFixed(2) ||
            parseFloat(item.saler_prov_take).toFixed(2) !=
              parseFloat(item.take_commission).toFixed(2) ||
            parseFloat(item.saler_fee_take).toFixed(2) !=
              parseFloat(item.insurer_fee).toFixed(2))
        ) {
          this.addToChangedIds(item.id);
        }
      });
    },
    setConfirmedRows(data) {
      data.forEach((item) => {
        this.setConfirmedRow(item.id);
      });
    },
    setConfirmedRow(id) {
      // setta confirmed... mah..
      let item = this.$refs[this.tableRef].items.find((e) => e.id == id);
      // console.log("item:", item);
      if (item) {
        item.is_confirmed.value = "Y";
        // console.log("==========================");
      }
    },
    // isInChangedIds(id) {
    //   return this.changedIds.indexOf(id) === -1
    // },
    scrollTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    updateCall(item) {
      let payload = {};
      payload["agency_prov_purchase"] = item?.agency_prov_purchase;
      payload["agency_prov_take"] = item?.agency_prov_take;
      payload["saler_prov_purchase"] =
        this.calculus_type == 0
          ? item.saler_prov_purchase
          : item.purchase_commission;
      payload["saler_prov_take"] =
        this.calculus_type == 0 ? item.saler_prov_take : item.take_commission;
      payload["saler_fee_take"] = item?.insurer_fee;
      payload["is_confirmed"] = item?.is_confirmed?.value;
      payload["is_statement_excluded"] = "N"; // item.is_statement_excluded.value;

      const Repo = RepositoryFactory.get("book_entry");
      return Repo.commission_update(item.id, payload);
    },
    updateOne(item) {
      // save only if changes occurred
      let index = this.changedIds.indexOf(item.id);
      if (index !== -1) {
        this.isUpdating = true;
        this.updateCall(item)
          .then(() => {
            // tolgo da changedIds..
            this.changedIds.splice(index, 1);
            this.$showSnackbar({
              preset: "success",
              text: `Hai aggiornato la riga`,
            });

            // se è l'ultimo, ricarico la table, in modo che riesegue le operazioni post-fetch
            // quali ad esempio la colorazione delle celle etc...
            this.isUpdating = false;
            if (!this.changedIds.length) {
              //   // this.$nextTick(() => {
              this.onSearch(this.filterName);
              //   // });
            }
            // // if(!this.changedIds.length) {
            // //   // bottone Rendiconto
            // //   this.canBrokerStatement = true;
            // // }
          })
          .catch((error) => {
            this.isUpdating = false;
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
          });
      } else {
        this.$showSnackbar({
          preset: "info",
          text: `La riga non è ancora stata modificata: niente da salvare`,
        });
      }
    },
    /* updateAll() {
      // filtra le righe da aggiornare tenendo solo quelle in this.changedIds
      let promises = [];
      let rows = this.$refs[this.tableRef].items.filter(
        (item) =>
          this.changedIds.includes(item.id) &&
          this.$refs[this.tableRef].isChangeable(item)
      );
      this.isUpdating = true;
      for (let index = 0; index < rows.length; index++) {
        const row = rows[index];
        promises.push(this.updateCall(row));
      }
      Promise.all(promises)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            // text: `Hai aggiornato le righe (ID: [${this.changedIds.join(
            //   ", "
            // )}])`,
            text: "Hai aggiornato tutte le righe",
          });
          this.changedIds = [];
          this.isUpdating = false;
          this.onSearch(this.filterName);
          // bottone Rendiconto
          // this.canBrokerStatement = true;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    }, */
    updateAll() {
      // #1112 call bulk_update
      const Repo = RepositoryFactory.get(this.repository);

      // filtra le righe da aggiornare tenendo solo quelle in this.changedIds
      let bulkBody = {};
      let rows = this.$refs[this.tableRef].items.filter(
        (item) =>
          this.changedIds.includes(item.id) &&
          this.$refs[this.tableRef].isChangeable(item),
      );
      this.isUpdating = true;
      for (let index = 0; index < rows.length; index++) {
        const row = rows[index];
        const id = row.id;
        // promises.push(this.updateCall(row));
        const body = {
          saler_prov_purchase:
            this.calculus_type == 0
              ? row.saler_prov_purchase
              : row.purchase_commission,
          saler_prov_take:
            this.calculus_type == 0 ? row.saler_prov_take : row.take_commission,
          // saler_fee_take: row.saler_fee_take, // #1112
          saler_fee_take:
            this.calculus_type == 0 ? row.saler_fee_take : row.insurer_fee, // #1112
          // book_date: row.book_date,
          // effective_date: row.effective_date,
          // sheet_date: row.sheet_date,
          // net: row.net,
          // gross: row.gross,
          // // salesman_id: row.salesman_id, // ??? row non ha salesman_id, e il v-model qui è this.salesman_id
          // insurer_id: row.insurer_id,
          is_confirmed: row.is_confirmed.value,
          // broker: {
          //   [row.brokers[0].id]: {},
          // },
          // various_accounting: {
          //   [row.various_accountings[0].id]: {
          //     insurance_risk_id:
          //       row.various_accountings[0].pivot.insurance_risk_id,
          //   },
          // },
        };
        // this.setRequiredWithoutAll(body, row);
        bulkBody[id] = body;
      }

      Repo.bulk_update(bulkBody)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            // text: `Hai aggiornato le righe (ID: [${this.changedIds.join(
            //   ", "
            // )}])`,
            text: "Hai aggiornato tutte le righe",
          });
          this.changedIds = [];
          this.isUpdating = false;
          this.onSearch(this.filterName);
          // bottone Rendiconto
          // this.canBrokerStatement = true;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    setRequiredWithoutAll(body, row) {
      // 1. "insurance_ancillary"
      // 2. "insurer_accounting"
      // 3. "various_accounting"

      // 1. insurance_ancillaries
      if (row.insurance_ancillaries && row.insurance_ancillaries.length) {
        const insurance_ancillary_id = row.insurance_ancillaries[0].id;

        body["insurance_ancillary"] = {
          [insurance_ancillary_id]: {},
        };
      }

      // 2. insurer_accounting
      // TODO: ???

      // 3. various_accounting
      if (row.various_accountings && row.various_accountings.length) {
        const various_accountings_id = row.various_accountings[0].id;

        body["various_accounting"] = {
          [various_accountings_id]: {
            insurance_risk_id:
              row.various_accountings[0].pivot.insurance_risk_id,
          },
        };
      }
    },
    drawBrokerStatement() {
      // se il produttore intProd non è selezionato, il bottone ufficializza è disabilitato
      if (!this.salesman_id) {
        this.$showSnackbar({
          preset: "info",
          text: "Per poter ufficializzare il rendiconto, occorre selezionare un produttore in Intestazione documenti prodotti",
        });
      }
      // 1. mettere in sola lettura il checkbox e i campi input della table
      let table = this.$refs[this.tableRef];
      table.isTableReadonly = true;
      // GET /api/book_entries?byTotals=W&byAttribute[id]=X&byBroker[id]=Y&page=0
      const Repo = RepositoryFactory.get("book_entry");
      let book_entry_ids = this.$refs[this.tableRef].selectedRows.join(",");
      let broker_ids = this.salesmen_ids.join(",");
      let queryString = `byTotals[id]=${this.salesman_id}&byAttribute[id]=${book_entry_ids}&byBroker[id]=${broker_ids}`;

      Repo.index(queryString)
        .then((response) => {
          this.setTotalizers(response.data.data[0]);
          // mostrare bottone "Ufficializza rendiconto"
          this.canShowBrokerStatement = true;
          this.$nextTick(() => this.scrollTo("anchor1"));
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        });
    },
    getTotalizers() {
      return [
        { [this.getDictionary("premiums")]: this.summary.entrate },
        {
          [this.getDictionary("of_which_deferred_to_collect")]:
            this.summary.sospesi,
        },
        { [this.getDictionary("advance_payments")]: this.summary.acconti },
        { [this.getDictionary("commissions")]: this.summary.provvigioni },
        { [this.getDictionary("of_which_not_taxable")]: this.summary.di_cui },
        {
          [`${this.getDictionary("deduction")} (${
            this.summary.ritenuta_perc
          }%)`]: this.summary.ritenuta,
        },
        { [this.getDictionary("fees")]: this.summary.di_cui_diritti }, // #1112
        {
          [this.getDictionary("commissions_to_liquidate")]:
            this.summary.da_liquidare,
        },
        { [this.getDictionary("premiums_balance")]: this.summary.saldo },
      ];
    },
    setTotalizers(data) {
      this.summary.ritenuta_perc = parseFloat(data.broker_wht);
      this.summary.entrate = parseFloat(data.gross);
      this.summary.sospesi = parseFloat(data.deferred);
      this.summary.acconti = parseFloat(data.deposit);
      this.summary.provvigioni =
        parseFloat(data.purchase) + parseFloat(data.take);
      this.summary.di_cui =
        parseFloat(data.purchase_tax) + parseFloat(data.take_tax);
      this.summary.di_cui_diritti = parseFloat(data.fees);
      this.summary.ritenuta = parseFloat(data.deduction);
      // this.summary.da_liquidare = data.purchase + data.take - data.deduction;
      // this.summary.saldo =
      //   data.gross -
      //   data.deposit -
      //   (data.purchase + data.take) +
      //   data.deduction;
      this.summary.da_liquidare =
        parseFloat(data.purchase) +
        parseFloat(data.take) -
        parseFloat(data.deduction) +
        parseFloat(data.fees);
      this.summary.saldo =
        parseFloat(data.gross) -
        (parseFloat(data.purchase) + parseFloat(data.take)) +
        parseFloat(data.deduction) -
        parseFloat(data.fees);
    },
    sumRitenute(data, keys) {
      let hasChecks = true;
      let tot = 0;
      keys.forEach((key) => {
        let parts = key.split(".");
        tot += data
          .map((row) => {
            // somma solo se in presenza dei check, sono checkati e se ancillaries è vuoto e se various è diveso da 1
            return (!hasChecks || (hasChecks && row.check)) &&
              // !row.insurance_ancillaries.length &&
              // row.various_accountings[0].code != "FC"
              row.is_taxable.value === "N"
              ? +parseFloat(parts.reduce((acc, part) => acc && acc[part], row))
              : 0;
          })
          .reduce((sum, i) => {
            return sum + i;
          }, 0);
      });
      return tot;
    },
    sumPositiveAdvancePayment(data) {
      let hasChecks = true;
      let tot = 0;
      data.forEach((item) => {
        if (!item.entry_details) {
          return;
        }
        tot += item.entry_details
          .map((row) => {
            return (!hasChecks || (hasChecks && item.check)) &&
              row.treasury.code == "AC" &&
              row.gross > 0
              ? parseFloat(row.gross)
              : 0;
          })
          .reduce((sum, i) => {
            return sum + i;
          }, 0);
      });
      return tot;
    },
    sumNegativeAdvancePayment(data) {
      let hasChecks = true;
      let tot = 0;
      data.forEach((item) => {
        if (!item.entry_details) {
          return;
        }
        tot += item.entry_details
          .map((row) => {
            return (!hasChecks || (hasChecks && item.check)) &&
              row.treasury.code == "AC" &&
              row.gross < 0
              ? parseFloat(row.gross)
              : 0;
          })
          .reduce((sum, i) => {
            return sum + i;
          }, 0);
      });
      return tot;
    },
    sumSospesi(data) {
      // sommare tutti i gross dei dettagli con cassa sospesi (id=3 or code=SS)
      let hasChecks = true;
      let tot = 0;
      data.forEach((item) => {
        if (!item.entry_details) {
          return;
        }
        tot += item.entry_details
          .map((row) => {
            // somma solo se in presenza dei check, sono checkati e se è una cassa sospesi
            return (!hasChecks || (hasChecks && item.check)) &&
              row.treasury.code == "SS"
              ? +parseFloat(row.gross)
              : 0;
          })
          .reduce((sum, i) => {
            return sum + i;
          }, 0);
      });
      return tot;
    },
    sumSospesiSummary(data) {
      // sommare tutti i gross_deferred
      // REVIEW: in futuro anche questa cambierà...
      let hasChecks = true;
      let tot = 0;
      tot = data
        .map((row) => {
          // somma solo se in presenza dei check, sono checkati e se esiste gross_deferred
          return (!hasChecks || (hasChecks && row.check)) && row.gross_deferred
            ? +parseFloat(row.gross_deferred)
            : 0;
        })
        .reduce((sum, i) => {
          return sum + i;
        }, 0);
      return tot;
    },
    sumAdvancePaymentSummary(data, field) {
      // sommare tutti i deposit_in
      // REVIEW: in futuro anche questa cambierà...
      let hasChecks = true;
      let tot = 0;
      tot = data
        .map((row) => {
          // somma solo se in presenza dei check, sono checkati e se esiste gross_deferred
          return (!hasChecks || (hasChecks && row.check)) && row[field]
            ? +row[field]
            : 0;
        })
        .reduce((sum, i) => {
          return sum + i;
        }, 0);
      return tot;
    },
    sumDiritti(data, keys) {
      let hasChecks = true;
      let tot = 0;
      keys.forEach((key) => {
        let parts = key.split(".");
        tot += data
          .map((row) => {
            // somma solo se in presenza dei check, sono checkati
            return !hasChecks || (hasChecks && row.check) // &&
              ? // !row.insurance_ancillaries.length &&
                // row.various_accountings[0].code != "FC"
                // row.is_taxable.value === "N"
                +parts.reduce((acc, part) => acc && acc[part], row)
              : 0;
          })
          .reduce((sum, i) => {
            return sum + i;
          }, 0);
      });
      return tot;
    },
    onSaveBrokerStatement() {
      // payload must contain:
      // salesman_id (presi dal filtro originale)
      // date_from  (presi dal filtro originale)
      // date_to (presi dal filtro originale)
      // numero fattura (al momento text)
      // periodo (al momento text)
      // array di bookentry (presi da selectedRows)
      if (!this.form.invoice_period || !this.form.invoice_number) {
        this.showConfirm({
          yesCallback: () => {
            this.saveBrokerStatement();
          },
          noCallback: null,
          title: "Conferma",
          message:
            "Uno dei campi Numero Fattura/Periodo è vuoto. Procedere comunque?",
          yesLabel: "Procedi",
          yesVariant: "primary",
          noLabel: "Annulla",
          // yesVariant:
          // noVariant:
          // headerBgVariant:
        });
      } else {
        this.showConfirm({
          yesCallback: () => {
            this.saveBrokerStatement();
          },
          noCallback: null,
          title: "Conferma",
          message: "Procedere e ufficializzare il rendiconto?",
          yesLabel: "Procedi",
          yesVariant: "outline-lisaweb",
          noLabel: "Annulla",
          // yesVariant:
          // noVariant:
          // headerBgVariant:
        });
      }
    },
    /* saveBrokerStatement() {
      this.isSaving = true;
      let payload = {};
      let ids = this.$refs[this.tableRef].selectedRows.join(",");
      let filterString = `byAttribute[id]=${ids}`;
      // payload.salesman = { [this.salesman_id]: {} };
      payload.broker_id = this.salesman_id;
      payload.from = this.filter.byCalendar.from;
      payload.to = this.filter.byCalendar.to;
      payload.invoice_number = this.form.invoice_number;
      payload.invoice_period = this.form.invoice_period;
      // CHECK this out!!!
      // payload.book_entry = { id: this.$refs[this.tableRef].selectedRows };
      // console.debug("payload: ", payload);
      // #740: salvare il summary in totalizers
      let totalizers = this.getTotalizers();
      payload.totalizers = totalizers;
      // amount_due
      payload.amount_due = this.summary.saldo;
      // is_collected = N
      payload.is_collected = "N";

      const RepoBrokerStatement = RepositoryFactory.get("broker_statement");
      const Repo = RepositoryFactory.get(this.repository);
      RepoBrokerStatement.store(payload)
        .then((response) => {
          let id = response.data.data.id;
          payload = {
            broker_statement_id: id,
          };
          Repo.filter_update(payload, filterString)
            .then(() => {
              this.$showSnackbar({
                preset: "info",
                text: "Rendiconto ufficializzato",
              });
              // TODO #849: 2 chiamate per PDF una con percentuali=Y e una con percentuali=N
              this.exportAll(id)
                .then(() => {
                  this.$showSnackbar({
                    preset: "info",
                    text: `Richiesta accettata: report in elaborazione`,
                  });
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: errMsg,
                  });
                });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            })
            .finally(() => {
              this.isSaving = false;
              this.resetPage();
              this.onClearFilter(this.filterName);
              this.showCollapse1 = true;
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    }, */
    saveBrokerStatement() {
      this.isSaving = true;
      let payload = {};
      // let ids = this.$refs[this.tableRef].selectedRows.join(",");
      payload.broker_id = this.salesman_id;
      payload.from = this.filter.byCalendar.from;
      payload.to = this.filter.byCalendar.to;
      payload.invoice_number = this.form.invoice_number;
      payload.invoice_period = this.form.invoice_period;
      // payload.amount_due = this.summary.saldo;
      payload.is_collected = "N";
      payload.book_entry = this.$refs[this.tableRef].selectedRows;

      const RepoBrokerStatement = RepositoryFactory.get("broker_statement");
      RepoBrokerStatement.store(payload)
        .then((response) => {
          let id = response.data.data.id;
          this.$showSnackbar({
            preset: "info",
            text: "Rendiconto ufficializzato",
          });
          this.saveLastSelectedSalesman(this.salesman_id);
          // TODO #849: 2 chiamate per PDF una con percentuali=Y e una con percentuali=N
          this.exportAll(id)
            .then(() => {
              this.$showSnackbar({
                preset: "info",
                text: `Richiesta accettata: report in elaborazione`,
              });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isSaving = false;
          // maintain dates (feat/accounting-prod-maintain-dates)
          const calendar_from = this.filter.byCalendar.from;
          const calendar_to = this.filter.byCalendar.to;
          this.resetPage();
          this.onClearFilter(this.filterName);
          if (calendar_from) this.filter.byCalendar.from = calendar_from;
          if (calendar_to) this.filter.byCalendar.to = calendar_to;
          // re-store the filters
          const criteria = this.filter;
          const name = this.filterName;
          // store the filter
          this.saveFilterByName({ name, criteria });
          this.showCollapse1 = true;
        });
    },
    exportAll(broker_statement_id) {
      // non così: altra modalità senza queryString e con solo broker_statement_id
      // this.onExport(
      //   "pdf",
      //   "RENPROV",
      //   {
      //     // prospetto: this.getTotalizers(),
      //     produttori: this.salesmen_ids,
      //     salesman_id: this.salesman_id,
      //     show_percentages: "Y",
      //   },
      //   true // silent
      // );
      // this.onExport(
      //   "pdf",
      //   "RENPROV",
      //   {
      //     prospetto: this.getTotalizers(),
      //     produttori: this.salesmen_ids,
      //     salesman_id: this.salesman_id,
      //     show_percentages: "N",
      //   },
      //   true // silent
      // );
      // devo inviare broker_statement_id, senza queryString e con questo payload
      let promises = [];
      let report_id = this.$store.state.auth.reports.find(
        (e) => e.code === "RENPROV",
      ).id;
      const Repo = RepositoryFactory.get("book_entry");

      let payload = {
        format: "pdf",
        report_id,
        show_percentages: null,
        broker_statement_id,
      };
      payload.show_percentages = "Y";
      promises.push(Repo.report_rendiconto(null, payload));
      payload.show_percentages = "N";
      promises.push(Repo.report_rendiconto(null, payload));
      payload.format = "csv";
      payload.show_percentages = "Y";
      promises.push(Repo.report_rendiconto(null, payload));
      payload.show_percentages = "N";
      promises.push(Repo.report_rendiconto(null, payload));
      payload.format = "pdf";
      payload.fattura_proforma = "Y";
      promises.push(Repo.report_rendiconto(null, payload));
      return Promise.all(promises)
        .then(() => {})
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onCalculusTypeChange(checkedOption) {
      console.debug("checkedOption: ", checkedOption);
      // this.$showSnackbar({
      //   preset: "info",
      //   text: "Non implementato",
      //   actionText: "OK",
      // });
      if (!checkedOption) {
        this.filter.byExclusion = null;
      }
      this.changedIds = [];
      // reset items
      this.$refs[this.tableRef].items = [];
      // reset checkAll checkbox
      // this.$refs[this.tableRef].checkAll = false;
      // maintain dates (feat/accounting-prod-maintain-dates)
      const calendar_from = this.filter.byCalendar.from;
      const calendar_to = this.filter.byCalendar.to;
      this.resetPage();
      if (calendar_from) this.filter.byCalendar.from = calendar_from;
      if (calendar_to) this.filter.byCalendar.to = calendar_to;
      // re-store the filters
      const criteria = this.filter;
      const name = this.filterName;
      // store the filter
      this.saveFilterByName({ name, criteria });
    },
    onOpenGenerateBrokerStatements(mode) {
      switch (mode) {
        case "broker_statement_mode":
          this.broker_statement_header = "Genera Rendiconti";
          this.broker_statement_title =
            "Stai per generare i rendiconti dei produttori selezionati";
          this.mode = "broker_statement_mode";
          break;
        case "commission_mode":
          this.broker_statement_header = "Effettua Calcoli Provvigionali";
          this.broker_statement_title =
            "Stai per generare i calcoli provvigionali dei produttori selezionati";
          this.mode = "commission_mode";
          break;
      }
      this.$bvModal.show(this.generateBrokerStatementModalRef);
    },

    onGenerate(form) {
      this.$bvModal.hide(this.generateBrokerStatementModalRef);

      const Repo = RepositoryFactory.get("book_entry");
      let text = "";
      if (this.mode === "commission_mode") {
        form["no_statement"] = "Y";
        text = "Processo di calcolo provvigionale avviato";
      } else {
        form["no_statement"] = "N";
        text = "Processo di generazione dei rendiconti avviato";
      }

      Repo.generate_broker_statements(form)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      if (this.salesmen_ids?.length) {
        const filterKey = this.calculus_type
          ? "byCommissionApplied.id"
          : "byBroker.id";
        const staleKey = this.calculus_type
          ? "byBroker.id"
          : "byCommissionApplied.id";

        if (this.salesmen_ids.length === 1) {
          this.activeFilters[filterKey] = this.getSalesmen().find(
            (e) => e.value === this.salesmen_ids[0],
          ).text;
        } else {
          this.activeFilters[
            filterKey
          ] = `${this.salesmen_ids.length} selezioni`;
        }
        delete this.activeFilters[staleKey];
      } else {
        delete this.activeFilters["byBroker.id"];
        delete this.activeFilters["byCommissionApplied.id"];
      }

      delete this.activeFilters["byAttribute.is_statement_excluded"];
      return this.activeFilters;
    },
    onSearch(name, skipPrevCheckedItems = false) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (
        !this.salesmen_ids.length ||
        !this.salesman_id ||
        !this.filter.byCalendar.from ||
        !this.filter.byCalendar.to
      ) {
        let missing = {};
        missing.produttore = !this.salesmen_ids.length;
        missing.intestazione = !this.salesman_id;
        missing.registrazione_dal = !this.filter.byCalendar.from;
        missing.registrazione_al = !this.filter.byCalendar.to;
        let msg = `Devi selezionare ${Object.keys(missing)
          .filter((key) => missing[key])
          .join(", ")}`;
        this.$showSnackbar({
          preset: "info",
          text: msg,
          showAction: false,
        });
      } else {
        // #640
        // TODO: effettuare una chiamata di ricerca dei rendiconti già esistenti per sapere se un altro qualsiasi rendiconto di quello stesso produttore (quello in “Intestazione documenti prodotti”) copre le stesse date del range scelto. Se no, tutto a posto, se sì, mostrare modale con avviso “Esiste già un altro rendiconto per il periodo scelto, vuoi continuare?”, se sì tutto a posto, se no, nascondere i risultati e mostrare di nuovo i filtri di ricerca.
        const RepoBrokerStatement = RepositoryFactory.get("broker_statement");
        const queryString = `byBroker[id]=${this.salesman_id}&byBetweenFromTo=${this.filter.byCalendar.from},${this.filter.byCalendar.to}`;
        RepoBrokerStatement.index(queryString).then((response) => {
          if (response.data.data.length) {
            this.showConfirm({
              yesCallback: () => {
                this.fetchData(name, skipPrevCheckedItems);
              },
              noCallback: () => {
                this.resetPage();
              },
              title: "Conferma",
              message: `Esistono già rendiconti in questo range (${this.filter.byCalendar.from}, ${this.filter.byCalendar.to}). Procedere comunque?`,
              yesLabel: "Procedi",
              yesVariant: "primary",
              noLabel: "Annulla",
            });
          } else {
            this.fetchData(name, skipPrevCheckedItems);
          }
        });
        // Fintanto che non esiste un filtro adatto al TODO qui sopra...
        // this.fetchData(name);
      }
    },
    fetchData(name, skipPrevCheckedItems = false) {
      // some handles for the fetch call...
      let args = { items: { handle: null, params: [] }, verb: {} };
      // 1. items handle
      args.items.handle = this.manipolaItems;
      let previous = this.filter.byCalendar.from;
      if (this.arretrati) {
        this.filter.byCalendar.from = "1900-01-01";
      }
      // TODO: nuovo filtro per escludere dal ricalcolo provvigionale
      // compagnie e i rami indicati nell’anagrafica Compagnie
      // if (this.filter.byExclusion) {
      //   // byInsurer[exclude_calc_vehicle_branch|exclude_calc_extra_vehicle_branch|exclude_calc_life_branch]=N
      //   this.filter.byInsurer.exclude_calc_vehicle_branch = "N";
      //   this.filter.byInsurer.exclude_calc_extra_vehicle_branch = "N";
      //   this.filter.byInsurer.exclude_calc_life_branch = "N";
      // } else {
      //   this.filter.byInsurer.exclude_calc_vehicle_branch = null;
      //   this.filter.byInsurer.exclude_calc_extra_vehicle_branch = null;
      //   this.filter.byInsurer.exclude_calc_life_branch = null;
      // }

      // DEBUG
      // this.filter.bySalesman = {};
      // this.filter.bySalesman.id = this.salesman_id;

      if (this.calculus_type) {
        // 2. verb handle, a replacement for index
        args.verb.name = "summary";
        args.verb.alias = "index";
        this.filter.byCommissionApplied = {};
        // enable BE calculus
        this.filter.byCommissionApplied.id = this.salesmen_ids.join(",");
        // do not add broker to query string
        this.filter.byBroker = {};
      } else {
        // add broker to query string
        this.filter.byBroker = {};
        // do not add byCommissionApplied to query string
        this.filter.byCommissionApplied = {};

        this.filter.byBroker.id = this.salesmen_ids.join(",");
      }
      let criteria = this.filter;
      // store the filter
      this.saveFilterByName({ name, criteria });
      // save for report..
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      // this.removePaginationByName(name);
      // store the pagination 1000
      // criteria = { perPage: 1000, currentPage: 1}
      // this.savePaginationByName({ name, criteria});

      if (!skipPrevCheckedItems) {
        // keep the previous checked items
        this.keepPrevCheckedItemIds();
      } else {
        this.prevCheckedItemIds = [];
      }
      // reset checkAll checkbox
      this.$refs[this.tableRef].checkAll = false;
      this.$refs[this.tableRef].items = [];
      // reset readonly
      this.$refs[this.tableRef].isTableReadonly = false;
      // fetch data
      this.$refs[this.tableRef].fetch(args).then(() => {
        if (this.$refs[this.tableRef]?.items?.length) {
          this.$refs[this.tableRef]?.items.forEach((el) => {
            /* */
            el["registry_title"] = this.toCustomer(el);
            if (this.rowClass(el) === "purple") {
              el["registry_title"] += ` / ${this.toBranchAndRisk(el)}`;
            }
            /* */
            el["registry_group"] = this.toRegistryGroup(el);
            el["insurance_policy_number"] = this.toPolicy(el)?.toString() ?? "";
            el["book_tag_code"] = this.toBookTag(el);
            el["company_code"] = this.toCompany(el);
            /* */
            if (this.rowClass(el) !== "purple") {
              el["branch_risk_title"] = this.toBranchAndRisk(el);
            }
            /* */
            el["perc_prov_ag_acq"] = this.percentageProvAgAcq(el);
            el["perc_prov_ag_inc"] = this.percentageProvAgInc(el);
            el["prov_ag_tot"] = this.provAgTot(el);
            el["tot_prod"] = this.totProd(el);
            el["perc_prov_ag_tot"] = this.percentageProvAgTot(el);
            el["perc_prov_prod_acq_ag"] = this.percentageProvProdAcqAg(el);
            el["perc_prov_prod_acq_im"] = this.percentageProvProdAcqIm(el);
            el["perc_prov_prod_inc_ag"] = this.percentageProvProdIncAg(el);
            el["perc_prov_prod_inc_im"] = this.percentageProvProdIncIm(el);
            el["perc_prov_prod_tot_ag"] = this.percentageProvProdTotAg(el);
            el["perc_prov_prod_tot_im"] = this.percentageProvProdTotIm(el);
          });
        }
        // set summary.ritenuta_perc from first item's broker.attributables.WHT
        // if (this.$refs[this.tableRef].items.length) {
        //   // NOTE nel caso Calcola con Lisaweb, item non ha la proprietà "brokers", quindi metto a 0
        //   this.summary.ritenuta_perc = this.$refs[this.tableRef].items[0]
        //     .brokers
        //     ? this.$refs[this.tableRef].items[0].brokers[0].attributables.WHT
        //       ? this.$refs[this.tableRef].items[0].brokers[0].attributables.WHT
        //       : 0
        //     : 0;
        // }
        // setChangedIds
        if (this.calculus_type == 1) {
          this.setChangedIds(this.$refs[this.tableRef].items);
          // // REVIEW mettere is_confirmed = Y??? o solo per calculus_type = 1
          // this.setConfirmedRows(this.$refs[this.tableRef].items);
        }
        // if(this.arretrati) {
        this.filter.byCalendar.from = previous;
        // }
        // this.resetPage();
        // #986: reimpostare i check come erano, se ce ne sono
        if (this.prevCheckedItemIds?.length) {
          this.setPrevCheckedItemIds();
        } else {
          // default: pre-select all
          this.$refs[this.tableRef].checkAll = true;
          this.$refs[this.tableRef].selectAll();
        }
      });
      this.showCollapse1 = false;
    },
    keepPrevCheckedItemIds() {
      this.prevCheckedItemIds = this.$refs[this.tableRef].items
        .filter((e) => e.check)
        .map((e) => e.id);
    },
    setPrevCheckedItemIds() {
      for (const id of this.prevCheckedItemIds) {
        let found = this.$refs[this.tableRef].items.find((e) => e.id === id);
        if (found) {
          found.check = true;
        }
      }
      if (
        this.prevCheckedItemIds.length &&
        this.prevCheckedItemIds.length ===
          this.$refs[this.tableRef].items.length
      ) {
        this.$refs[this.tableRef].checkAll = true;
      } else {
        this.$refs[this.tableRef].checkAll = false;
      }
    },
    manipolaItems(data) {
      // sort by "color": purple, white, pink
      // split data into subsets, sort each by book_date, then concat back
      let purples, whites, pinks;
      purples = data
        .filter(
          (item) =>
            // !item.insurance_ancillaries.length &&
            item.various_accountings &&
            item.various_accountings.length &&
            // item.various_accountings[0].code !== "FC"
            item.various_accountings[0].code === "CP",
        )
        .sort((a, b) => a.book_date.localeCompare(b.book_date));
      pinks = data
        .filter(
          (item) =>
            moment(item.book_date).diff(moment(this.filter.byCalendar.from)) <
            0,
        )
        .sort((a, b) => a.book_date.localeCompare(b.book_date));
      // not purples and not pinks...
      whites = data
        .filter(
          (item) =>
            !(
              // !item.insurance_ancillaries.length &&
              (
                item.various_accountings &&
                item.various_accountings.length &&
                // item.various_accountings[0].code !== "FC"
                item.various_accountings[0].code === "CP"
              )
            ) &&
            !(
              moment(item.book_date).diff(moment(this.filter.byCalendar.from)) <
              0
            ),
        )
        .sort((a, b) => a.book_date.localeCompare(b.book_date));
      let sortedData = [...purples, ...whites, ...pinks];
      // console.debug(
      //   `manipolaItems: before: ${data.length}, after: ${sortedData.length}`
      // );
      if (data.length !== sortedData.length) {
        this.$showSnackbar({
          preset: "info",
          text: "Non è possibile ordinare correttamente tutti i dati per colore",
          showAction: false,
        });
        sortedData = data;
      }
      // negativizzo gli acconti: se VariousAccounting è AC (id = 3), allora metto il segno - al gross

      return sortedData.map((item) => {
        if (
          item.various_accountings &&
          item.various_accountings.length &&
          item.various_accountings[0].code === "AC"
        ) {
          item.gross *= -1;
        }
        if (item.is_confirmed.value === "Y") {
          item.purchase_commission = item.saler_prov_purchase;
          item.take_commission = item.saler_prov_take;
          item.insurer_fee = item.saler_fee_take;
        }
        // console.log("Item: ", item);
        // aggiungo campi "volanti" reattivi per modificare...
        // this.$set(item, "take_commission", null);
        // this.$set(item, "purchase_commission", null);
        return item;
      });
    },
    calculatePercentage(amount, perc) {
      return parseFloat(((amount * perc) / 100).toFixed(2));
    },
    resetPage() {
      this.changedIds = [];
      // reset selected rows
      this.$refs[this.tableRef].selectedRows = [];
      // remove all checks
      this.$refs[this.tableRef].unselectAll();
      this.$refs[this.tableRef].checkAll = false;
      // enable input fields and checkboxes
      this.$refs[this.tableRef].isTableReadonly = false;
      // hide BrokerStatement button
      // this.canBrokerStatement = false;
      // hide BrokerStatement section
      this.canShowBrokerStatement = false;
      // reset form
      this.form.invoice_number = null;
      this.form.invoice_period = null;
    },
    onClearFilter(name) {
      this.myToggle = false;
      // this.$nextTick(() => {
      this.resetFilter();
      // reset salesman_id
      this.salesmen_ids = [];
      this.salesman_id = null;
      // reset arretrati
      this.arretrati = false;
      this.resetPagination();
      // remove from store
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      // clear the sortBy flag
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // fetch data
      // // this.$refs[this.tableRef].fetch();
      // NOTE: since salesman_id is mandatory, cannot fetch (with no filter), but must clear items instead!
      // this.onSearch(name);
      // reset changedIds
      this.changedIds = [];
      // reset items
      this.$refs[this.tableRef].items = [];
      // reset checkAll checkbox
      // this.$refs[this.tableRef].checkAll = false;
      this.resetPage();
      // });
    },
    onReset() {
      this.resetPage();
      this.$refs[this.tableRef].selectAll();
      this.$refs[this.tableRef].checkAll = true;
      this.onSearch(this.filterName, true);
    },
    rowClass(item) {
      let status = "white";
      if (!item) return status;
      // purple: "effective-status-0", // Movimento vario modificabile (VIOLA)
      if (!this.isChangeable(item)) status = "purple";
      return status;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {
      removePaginationByName: "removeByName",
      savePaginationByName: "saveByName",
    }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getInsurers: "insurers",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  mounted() {
    this.activeFilters = {};
    this.onCalculusTypeChange(this.calculus_type);
    // Initialize hiddenKeys from current field classes (if any are already hidden)
    this.hiddenKeys = this.selectableFields[0]
      .filter(
        (f) =>
          f.hideable &&
          /(?:^|\s)d-none(?:\s|$)/.test(
            (f.thClass || "") + " " + (f.class || ""),
          ),
      )
      .map((f) => f.key);
  },
  beforeMount() {
    this.calculus_type =
      Number.isNaN(this.prodmodValue) ||
      this.prodmodValue === null ||
      this.prodmodValue === undefined
        ? 1
        : this.prodmodValue;
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
    this.insurers = this.getInsurers();
    this.loadLastSelectedSalesman();
    // maintain dates (feat/accounting-prod-maintain-dates)
    const calendar_from = this.filter.byCalendar.from;
    const calendar_to = this.filter.byCalendar.to;
    // do not AUTOMATIC FETCH
    this.removeFilterByName(this.filterName);
    if (calendar_from) this.filter.byCalendar.from = calendar_from;
    if (calendar_to) this.filter.byCalendar.to = calendar_to;
  },
  deactivated() {
    // console.log("deactivated");
    // re-store the filters
    const criteria = this.filter;
    const name = this.filterName;
    // store the filter
    this.saveFilterByName({ name, criteria });
  },
  watch: {
    prodmodValue(newVal) {
      if (Number.isNaN(newVal) || newVal === null || newVal === undefined) {
        this.calculus_type = 1;
        this.onCalculusTypeChange(1);
      } else {
        this.calculus_type = newVal;
        this.onCalculusTypeChange(newVal);
      }
    },
  },
  computed: {
    hideableFieldOptions() {
      // only the fields with hideable: true
      return this.selectableFields[0]
        .filter((f) => f.hideable)
        .map((f) => ({
          text: f?.hideableLabel || f.label || f.key, // what user sees
          value: f.key, // the key we store in hiddenKeys
        }));
    },
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    isCalcWithLisa() {
      // TODO: check the real value
      return this.calculus_type == 1;
    },
    flds() {
      return this.selectableFields[
        this.$store.state.auth.settings.attribute_STATMOD_value
      ];
    },
    selRows() {
      return this.$refs[this.tableRef].selectedRows;
    },
    isUpd() {
      return this.isUpdating;
    },
    isSav() {
      return this.isSaving;
    },
    intProd() {
      // options per la seconda tendina dei produttori
      return this.getSalesmen().filter((e) =>
        this.salesmen_ids.includes(e.value),
      );
    },
    decoratedSalesmenSelect() {
      // marca visivamente l'ultimo produttore per cui è stato ufficializzato un rendiconto
      if (!this.lastSelectedSalesmanId) return this.salesmen_select;
      return this.salesmen_select.map((option) =>
        // eslint-disable-next-line eqeqeq
        option.value == this.lastSelectedSalesmanId
          ? {
              ...option,
              text: `🔵 ${option.text}`,
              title: "Ultimo produttore con rendiconto ufficializzato",
            }
          : option,
      );
    },
    smid() {
      return this.salesman_id;
    },
    smids() {
      return this.salesmen_ids;
    },
    isChangeable() {
      // per i 2 input currency
      return (item) => {
        return (
          this.isVarAccByCode(item, "FC") ||
          this.isVarAccByCode(item, "FCT") ||
          this.hasInsuranceAncillary(item)
        );
      };
    },
    isVarAccByCode() {
      // VariousAccounting by code
      return (item, code) => {
        // must return boolean
        return !!(
          item.various_accountings &&
          item.various_accountings.length > 0 &&
          item.various_accountings[0].code === code
        );
      };
    },
    // hasItems() {
    //   return this.$refs[this.tableRef] && this.$refs[this.tableRef].items.length
    // }
  },
};
</script>
<style scoped>
:deep(body:has(.v-sidebar-menu.vsm_collapsed) [data-type="overflow-x"]) {
  width: calc(100vw - (0.75rem * 2) - 2px - (0.25rem * 2) - (1rem * 2) - 50px);
  overflow-x: scroll;
}

:deep(body:has(.v-sidebar-menu.vsm_expanded) [data-type="overflow-x"]) {
  width: calc(100vw - (0.75rem * 2) - 2px - (0.25rem * 2) - (1rem * 2) - 240px);
  overflow-x: scroll;
}
</style>
<style lang="scss" scoped>
// Rendiconto: etichette nei th, importi nei td.
table.summary tbody td {
  --font-family: var(--font-family-num);
}

table.totals {
  background-color: white;
  width: 100%;
  table-layout: fixed;

  th {
    text-align: center;
  }

  td {
    text-align: right;
    font-weight: bold;
  }
}

table.summary {
  width: 50%;
  border-collapse: collapse;

  tbody {
    tr {
      text-transform: uppercase;

      &:nth-of-type(odd) {
        th,
        td {
          background-color: #fff !important;
        }
      }

      &:nth-of-type(even) {
        th,
        td {
          background-color: var(--gray-50) !important;
        }
      }

      &:hover {
        th,
        td {
          background-color: var(--lisaweb-light) !important;
        }
      }
    }
  }
}

table tr th,
td {
  width: 30%;
  padding: 2px 4px;
  text-align: left;
}

td {
  text-align: right;
}

th[scope="col"] {
  text-transform: uppercase;
}
</style>
<style lang="scss">
table input[type="text"] {
  field-sizing: content;
}

.bg-light-v2 {
  background: var(--gray-50) !important;
}

.bg-light-v3 {
  background: var(--gray-50) !important;
}

.italic {
  font-style: italic;
}

.bold {
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
:deep(.b-dropdown-form) {
  font-size: 0.8rem;
}

:deep(.b-dropdown-form .btn) {
  width: 100%;
}

:deep(.btn-group > .btn) {
  font-size: 0.75rem;
}

:deep(.dropdown-header) {
  font-size: 0.75rem;
  padding: 0.25rem 1.1rem;
  font-weight: 500;
  color: var(--color-text);
}

:deep(.dropdown-menu.show) {
  min-width: fit-content;
  margin: 6px 0 0 -7px;
  border: 2px solid var(--color-text);
  border-radius: 0.5rem;
}

:deep(.custom-checkbox),
:deep(.custom-checkbox *) {
  cursor: pointer;
}
</style>
